import React from "react";

import { Box, Stack, Typography } from "@mui/material";

import { PageContainer } from "@/components/containers";

const UnauthorizedPage: React.FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      height="calc(100vh - 57px - 48px - 32px)"
    >
      <Stack spacing={4} mt={10} alignItems="center">
        <Typography
          variant="h2"
          sx={{
            fontFamily: "cera-pro-bold",
          }}
        >
          —ACCESS DENIED—
        </Typography>
        <Typography>
          You do not have permission to view this page.
        </Typography>
      </Stack>
    </Box>
  );
};

export default UnauthorizedPage;
